import React, {useEffect, useRef, useState} from "react";
import {Button, Form, FormControl, InputGroup} from "react-bootstrap";
import {queryStringToHash, updateQueryString} from "./lib/utils";
import debounce from "lodash/debounce";

const SearchBox = ({placeholder, q, url}) => {
    const [jqxhr, setJqxhr] = useState(null);
    const [query, setQuery] = useState(q || '');
    const inputRef = useRef(null);

    const request = debounce((q) => {
        jqxhr?.abort();

        updateQueryString({q});
        setJqxhr($.ajax({
            type: 'GET',
            url,
            data: {
                ...queryStringToHash(), q
            },
        }));
    }, 500);
    const onSubmit = (e) => {
        e.preventDefault();
        return request(query);
    };
    useEffect(() => {
        inputRef.current.focus();
    }, [inputRef]);

    return <Form onSubmit={onSubmit}>
        <InputGroup>
            <FormControl placeholder={placeholder} ref={inputRef}
                         onChange={(e) => setQuery(e.target.value)}
                         value={query}
                         style={{width: '400px', maxWidth: '96vw'}}
            />
            <Button variant="outline-secondary" id="button-addon2" onClick={onSubmit}>
                <i className="fa fa-search"/>
            </Button>
        </InputGroup>
    </Form>;
}


export default SearchBox;